import { useEffect } from 'react';
import { useChannelTalk } from '../../hooks/useChannelTalk';

export const ChannelTalk = () => {
  const { showButton, hideButton } = useChannelTalk();

  useEffect(() => {
    showButton();

    return () => {
      hideButton();
    };
  }, []);

  return <></>;
};
